import { PACKAGES, EXTRA_PLUSH_PRICE } from "./data";

export const daysUntil = (iso) => {
  if (!iso) return null;
  const d = new Date(`${iso}T00:00:00`);
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return Math.round((d - t) / 86400000);
};

export const fmtDate = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("pt-BR") : "—");

export const hoursUntil = (iso, time) => {
  if (!iso) return null;
  return (new Date(`${iso}T${time || "00:00"}:00`) - new Date()) / 3600000;
};

export const isShortNotice = (iso, time) => {
  const h = hoursUntil(iso, time);
  return h !== null && h < 48;
};

export function calcPricing({ packageId, extras, option, eventDate, method }) {
  const pkg = PACKAGES.find((p) => p.id === packageId) || PACKAGES[0];
  const subtotal = pkg.price + (Number(extras) || 0) * EXTRA_PLUSH_PRICE;
  if (option === "full") {
    const discount = method === "pagarme" ? 0 : Math.round(subtotal * 5) / 100;
    return { pkg, subtotal, discount, total: subtotal - discount, dueNow: subtotal - discount, remaining: 0, dueDate: null };
  }
  const dueNow = Math.round(subtotal * 30) / 100;
  let dueDate = null;
  if (eventDate) {
    const d = new Date(`${eventDate}T00:00:00`);
    d.setDate(d.getDate() - 10);
    dueDate = d.toLocaleDateString("pt-BR");
  }
  return { pkg, subtotal, discount: 0, total: subtotal, dueNow, remaining: subtotal - dueNow, dueDate };
}

export const fieldCls =
  "h-12 rounded-xl bg-white/[0.04] border-white/10 text-white placeholder:text-zinc-500 focus-visible:ring-[#FFD200] focus-visible:ring-offset-0 [color-scheme:dark]";
